import styled from 'styled-components';
import { minWidth } from 'helpers/buildMediaQueries';
import MaterialUiSwitch from '@mui/material/Switch';
import {
  gutterVariables,
  Trustmark,
  colorsVariables,
  boxShadowsVariables,
  flexItemsCentered
} from '@trustedshops/tps-seo-shared-frontend-react-components';

export const TrustmarkImg = styled(Trustmark)`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  margin-right: ${gutterVariables.GUTTER_HALF};
`;

export const CertificationFilter = styled.div`
  text-align: left;
  margin: ${gutterVariables.GUTTER} 0;

  ${minWidth(
    'xl',
    `
    display: inline-flex;
    float: left;
    margin: ${gutterVariables.GUTTER_HALF} 0 0 0;
    margin-right: 70px;`
  )}
`;

export const CertificationFilterLabel = styled.div`
  ${flexItemsCentered};
`;

const switchBaseLeft = 3;

export const Switch = styled(MaterialUiSwitch)`
  .MuiSwitch-switchBase {
    left: ${switchBaseLeft}px;

    &:hover {
      background-color: transparent;
    }

    &.Mui-checked {
      color: ${colorsVariables.WHITE};
      transform: translateX(${24 - 2 * switchBaseLeft}px);

      &:hover {
        background-color: transparent;
      }

      & + .MuiSwitch-track {
        border: 1px solid ${colorsVariables.GREEN_600};
        background-color: ${colorsVariables.GREEN_500};
        opacity: 1;
      }
    }

    .MuiSwitch-thumb {
      background: ${colorsVariables.WHITE};
      border: 1px solid ${colorsVariables.GRAY_300};
      box-shadow: ${boxShadowsVariables.certificationFilterToggle};
      border-radius: 83px;
      width: 18px;
      height: 18px;
    }
  }

  .MuiSwitch-track {
    border: 1px solid ${colorsVariables.GRAY_500};
    background-color: ${colorsVariables.GRAY_200};
    opacity: 1;
    height: 12px;
  }
`;
